import { axiosInstance } from "@/api/axiosInstance";
import { assetsService } from "./assets";

export const companyService = {
  getCompanies: async (page = 0, size = 200) => {
    try {
      const response = await axiosInstance.get(`/companies`, {
        params: { page, size },
      });
      console.log(response.data)
      return response.data || [];
    } catch (error) {
      console.error("Error fetching company by ID:", error.message);
      throw error;
    }
  },
  getCompany: async (companyId) => {
    try {
      const response = await axiosInstance.get(`/companies/${companyId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching company by ID:", error.message);
      throw error;
    }
  },
  getCompaniesPaginated: async (page = 0, size = 20) => {
    try {
      const response = await axiosInstance.get(`/companies/all-companies-pg`, {
        params: { page, size },
      });
      return response.data || { result: [], totalPages: 1 };
    } catch (error) {
      console.error("Error fetching companies:", error.message);
      throw error;
    }
  },
  updateCompany: async (company) => {
    try {
      const response = await axiosInstance.put(
        `/companies/${company.id}`,
        company
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching company by ID:", error.message);
      throw error;
    }
  },
  deleteCompany: async (companyId) => {
    try {
      const response = await axiosInstance.delete(`/companies/${companyId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching company by ID:", error.message);
      throw error;
    }
  },
  createCompany: async ({
    companyName,
    industry,
    address,
    website,
    logo,
    numberOfEmployees,
    firstname,
    lastname,
    email,
    phoneNumber,
    password,
  }) => {
    try {
      const response = await axiosInstance.post(`/companies`, {
        companyName,
        industry,
        address,
        website,
        numberOfEmployees,
        firstname,
        lastname,
        email,
        phoneNumber,
        password,
      });
      if (logo) {
        await assetsService.uploadAsset({
          file: logo,
          contentType: "IMAGE",
          entityType: "COMPANY",
          entityId: response.data.id,
          description: "COMPANY_LOGO",
        });
      }
      return response.data;
    } catch (error) {
      console.error("Error creating company:", error.message);
      throw error;
    }
  },
};
